import axios from "axios";

import Config from "../../config";

const actionEditarPerfil = data => {
    
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/usuarios/editar-perfil`,
        data
    });
};

export default actionEditarPerfil;
